import { withEnvStage } from "./env";

export type OnboardingKey = "layout" | "audioCard" | "teachingThemeFilter";

const ONBOARDING_KEYS: OnboardingKey[] = [
  "layout",
  "audioCard",
  "teachingThemeFilter",
];

const storageKey = (key: OnboardingKey): string =>
  withEnvStage(`onboarding_${key}`);

// Guards against the same tour firing twice within a single page session
// (e.g. several components mounting the same tour trigger at once).
const sessionTriggered = new Set<OnboardingKey>();

export const hasSeenOnboarding = (key: OnboardingKey): boolean =>
  localStorage.getItem(storageKey(key)) === "true";

export const markOnboardingSeen = (key: OnboardingKey): void => {
  localStorage.setItem(storageKey(key), "true");
};

/**
 * Runs `run` at most once ever (persisted in localStorage) and at most once
 * per page session, no matter how many components call this concurrently.
 */
export const triggerOnboardingOnce = (
  key: OnboardingKey,
  run: () => void,
): void => {
  if (sessionTriggered.has(key) || hasSeenOnboarding(key)) return;
  sessionTriggered.add(key);
  markOnboardingSeen(key);
  run();
};

/** Clears every onboarding flag so all tours can be replayed. */
export const resetOnboarding = (): void => {
  sessionTriggered.clear();
  ONBOARDING_KEYS.forEach((key) => localStorage.removeItem(storageKey(key)));
  window.location.reload(); // Reload to reset any in-memory tour state (e.g. driver.js overlay).
};
